import { Component, Input } from '@angular/core';
import { OrganizationService } from '../_services/organization.service';

import { Organization } from '../_models/organization';

@Component({
  moduleId: module.id,
  templateUrl: 'create.org.component.html'
})

export class CreateOrgComponent {
  model: Organization;
  error: string;
  loading: boolean;
  success: boolean;

  constructor(
    private organizationService: OrganizationService
  ){}

  createOrg(model) {
    this.error = null;
    this.loading = true;
    this.success = false;

    this.organizationService.createOrg(model)
      .then(org => {
        this.success = true;
        this.model = org;
      })
      .catch(err => {
        this.error = JSON.parse(err._body).error;
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/orgs/create.org.component.ts